<template>
	<div class="container site__block">



		<div v-if="stream && stream_id == stream.id">
			<div class="row" v-if="stream !== null && stream.type === 'player'">
				<div class="col-12">
					<player :stream="stream.stream" v-if="stream !== null && stream.type === 'player'"/>
				</div>
			</div>
			<div class="row" v-if="stream !== null && stream.type === 'iframe'">
				<div class="col-12">
					<div class="embed-responsive embed-responsive-16by9">

						<iframe :src="stream.url" frameborder="0" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</div>
		<horse-placeholder v-else :placeholder="placeholder_msg"></horse-placeholder>
		<form-message scope="general-streams"></form-message>




		<div class="row pt-3 pb-3">
			<div class="col-12 col-lg-6 mb-2" :key="'media-chanel--'+channel.id" v-for="channel in channels">
				<router-link :to="{name: 'stream_with_id', params: {stream_id: channel.id} }" class="media channel" :class="{ 'channel--active': stream_id == channel.id }">
					<img :src="channel.icon ? channel.icon : 'https://via.placeholder.com/64/3fc531/FFFFFF/?text='+channel.name" class="mr-3" alt="...">
					<div class="media-body channel__body">
						<h5 class="mt-0">{{channel.name}}</h5>
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import Player from '@/components/Player';
	import store from '@/store';
	import HorsePlaceholder from '@/parts/horse-placeholder';
	import FormMessage from '@/parts/form-message';

	export default {
		name: "Stream",
		components:{
			Player,
			HorsePlaceholder,
			FormMessage
		},
		beforeRouteEnter(to, from, next) {


			store.dispatch('userRefreshAction').then((response)=>{

				if(typeof response.data.username !== 'undefined'){
					if(typeof to.params.stream_id !== 'undefined'){
						store.dispatch('getStream', to.params.stream_id);
					}
					next();
				}else{

					next({name: 'login', query: { redirect: to.fullPath }});

				}

			}).catch(function () {
				next();
			});

		},
		beforeRouteUpdate(to, from, next){
			if(typeof to.params.stream_id !== 'undefined'){
				store.dispatch('getStream', to.params.stream_id);
			}
			next();
		},

		watch:{
			isLoggedIn(value){
				if(!value){
					this.$router.push({name: 'login', query:{ redirect: this.$route.path }})
				}
			}
		},
		computed:{
			stream_id(){
				return this.$route.params.stream_id;
			},
			...Vuex.mapGetters([
				'stream',
				'channels'
			]),

			placeholder_msg(){
				if(typeof this.stream_id === 'undefined'){
					return 'Please select stream';
				}else if(this.stream === null && typeof this.stream_id !== 'undefined'){
					return 'Stream not available';
				}else{
					return '';
				}
			}
		},

	}
</script>


<style scoped>

</style>